import { isEmpty } from '@backmarket/utils/object/isEmpty'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addressIsEmpty(address: Record<string, any> | null): boolean {
  if (!address) return true

  return Object.values(address).every(isEmpty)
}
